import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/services/auth.service';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IniciativaDetalle} from 'src/app/interfaces/interfaces';
import{ ConfirmListadoTablaIniciativasComponent} from 'src/app/components/shared/confirm-listado-tabla-iniciativas/confirm-listado-tabla-iniciativas.component';




export interface equipoTrabajoList{
  id_usuario:number;
  nombre_usuario:string;
  id_rol:number;
  email_usuario:string;
}

@Component({
  selector: 'app-equipo-trabajo',
  templateUrl: './equipo-trabajo.component.html',
  styleUrls: ['./equipo-trabajo.component.css']
})
export class EquipoTrabajoComponent implements OnInit {
  idRolSeleccionado:number;
  emailUser:string;
  idIniciativa:string;
  listaEquipo:any[]=[];

  //Combos
  listaDesarrolladores:equipoTrabajoList[]=[];
  listaLider:equipoTrabajoList[]=[];
  listaAnalista:equipoTrabajoList[]=[];
  listaGestor:equipoTrabajoList[]=[];
  //Lider
  valoresLider:string;
  emailLider:string;
  comentarioLider:string;
  idlider:number; 
  mostrar:boolean=false;
  valores:number;

  //Analista
  emailAnalista:string;
  emailGestor:string;
  nombreAnalista:string;
  idUsuarioAnalista:number;
  comentarioAnalista:string;
  comentarioGestor:string;
  analista:equipoTrabajoList[]=[]
  gestor:equipoTrabajoList[]=[]
  lider:equipoTrabajoList[]=[]
  desarrollador:equipoTrabajoList[]=[]

  //Desarrollador
  emailDesarrollador:string;
  valoresDesarrollador:string;
  idRolDesarrollador:number;
  comentarioDesarrollador:string;


  agregarDesa:boolean=false;
  agregarLid:boolean=false;
  agregarAna:boolean=false;
  agregarGest:boolean=false;

  nombreEnlace:string;
  iniciativa: IniciativaDetalle;
  loadingGeneral: boolean = false;





  constructor(private dataService: DataService,
    private router: Router,
    private authService: AuthService,
    private notifier: NotifierService,
    public dialog:MatDialog) { 
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
      //return this.emailUser;
    });
  }

  ngOnInit(): void {
    this.idIniciativa = localStorage.getItem("editarIniciativaId");
    //Nos subscribimos al método para el rol seleccionado
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
    });
    //Cargamos los valores del equipo de trabajo
    this.getEquipoTrabajo();
  }

  //Método para cargar la lista de lideres
  getEquipoTrabajo()
  {
    this.dataService.getEquipoTrabajo(parseInt(this.idIniciativa)).subscribe(data => {
      this.listaEquipo = data['data'];

      this.verDetallesIniciativa(parseInt(this.idIniciativa));
      this.listaEquipo.forEach((element,index )=> {
        if(element['id_rol']==1 || element['id_rol']==2)
        {
          this.nombreEnlace=element['nombre_usuario'];
        }
        if(element['id_rol']==4)
        {
          this.agregarAna=false;
          this.analista.push(element);
        }
        if(element['id_rol']==5)
        {
          this.agregarGest=false;
          this.gestor.push(element);
        }
        if(element['id_rol']==6 || element['id_rol']==7)
        {
          this.agregarLid=false;
          this.lider.push(element);
        }
        if(element['id_rol']==8)
        {
          this.agregarDesa=false;
          this.desarrollador.push(element);
        }
      });
      
    });

  }

  //Detalles de la iniciativa
  
  verDetallesIniciativa(id: number) 
  {
    this.dataService.detalleIniciativa(id).subscribe(data => {
      if (data['objData']) 
      {
        this.iniciativa=data['objData']['folio_iniciativa'];
      }
    });
  }




  //Método para cargar la lista de lideres
  getListLideres(){
    this.dataService.getListLideres().subscribe(data => {
      this.listaLider = data['data'];
    });
  }

  
  //Método para cargar la lista de analistas
  getListAnalistas(){
    this.dataService.getListAnalistasTI().subscribe(data => {
      this.listaAnalista = data['data'];
    });
    
  }

  getListGest(){
    this.dataService.getGestoresCambio().subscribe(data => {
      this.listaGestor = data['data'];
    });
  }

  
  //Método para cargar la lista de desarrolladores
  getListDesarrolladores(){
    this.dataService.getListDesarrolladores().subscribe(data => {
      this.listaDesarrolladores = data['data'];
    });
    
  }

  agregarDesarrolladores(){
    this.valoresDesarrollador="";
    this.getListDesarrolladores();
    this.agregarDesa=true;
    

  }
   agregarLider(){
    this.getListLideres();
     this.agregarLid=true;
   }

   agregarAnalista(){
    this.emailAnalista="";
   this.getListAnalistas();
    this.agregarAna=true;
  }

  agregarGestor(){
    this.emailGestor="";
    this.getListGest();
    this.agregarGest=true;
  }

   //Método para guardar analista del equipo de trabajo
   guardarAnalista(email_usuario:string)
   {
    this.valores=email_usuario.indexOf("/");
    let nombreAnalista=email_usuario.substring(this.valores+1,email_usuario.length);
    this.emailAnalista=email_usuario.substring(0,this.valores);

    let valores={
      'id_iniciativa':this.idIniciativa,
      'email_usuario':this.emailAnalista,
      'id_rol':4,
      'comentario':this.comentarioAnalista,
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }
    this.dataService.insertIntegranteEquipo(valores).subscribe(
    data => {
      if (data['errorMessage']) 
      {
        this.agregarAna=false;
        this.lider=[];
        this.analista=[];
        this.gestor=[];
        this.getEquipoTrabajo();
        this.notifier.notify('error',data['errorMessage'] )
      }
      else{
        this.agregarAna=false;
        this.lider=[];
        this.analista=[];
        this.gestor=[];
        this.getEquipoTrabajo();
        this.notifier.notify('success', 'Analista de TI agregado correctamente.');
      }
    }
  );



   /* let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{opcion:9,etiqueta:'Analista de TI',nombreDesarrollador:nombreAnalista},disableClose:true,width: '500px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        
      }
      else{
            let valores={
              'id_iniciativa':this.idIniciativa,
              'email_usuario':this.emailAnalista,
              'id_rol':4,
              'comentario':this.comentarioAnalista,
              'email_usuarioLogin':this.emailUser,
              'idRol_usuarioLogin':this.idRolSeleccionado
            }
            this.dataService.insertIntegranteEquipo(valores).subscribe(
            data => {
              if (data['errorMessage']) 
              {
                this.notifier.notify('error',data['errorMessage'] )
              }
              else{
                this.agregarAna=false;
                this.lider=[];
                this.analista=[];
                this.getEquipoTrabajo();
                this.notifier.notify('success', 'Analista de TI agregado correctamente.');
              }
            }
          );
        
      }
  });*/



   }

   guardarGestor(email_usuario:string)
   {
    this.valores=email_usuario.indexOf("/");
    let nombreAnalista=email_usuario.substring(this.valores+1,email_usuario.length);
    this.emailGestor=email_usuario.substring(0,this.valores);
 
    let valores={
      'id_iniciativa':this.idIniciativa,
      'email_usuario':this.emailGestor,
      'id_rol':5,
      'comentario':this.comentarioGestor,
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }
    
    this.dataService.insertIntegranteEquipo(valores).subscribe(
    data => {
      if (data['errorMessage']) 
      {
        this.agregarAna=false;
        this.lider=[];
        this.gestor=[];
        this.analista=[];
        this.getEquipoTrabajo();
        this.notifier.notify('error',data['errorMessage'] )
      }
      else{
        this.agregarAna=false;
        this.lider=[];
        this.gestor=[];
        this.analista=[];
        this.getEquipoTrabajo();
        this.notifier.notify('success', 'Gestor de cambios agregado correctamente.');
      }
    }
  );
   }

   //Método para guardar lider de equipo de trabajo
   guardarLider(valoresLider:string)
   {
     this.valores=valoresLider.indexOf("/");
     this.idlider=parseInt(valoresLider.substring(this.valores+1,valoresLider.length));
     this.emailLider=valoresLider.substring(0,this.valores);
     let nombreLider=valoresLider.substring(this.valores+3,valoresLider.length);

     let valores={
      'id_iniciativa':this.idIniciativa,
      'email_usuario': this.emailLider,
      'id_rol':this.idlider,
      'comentario':this.comentarioLider,
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }
   this.dataService.insertIntegranteEquipo(valores).subscribe(
     data => {
       if (data['errorMessage']) 
       {
        this.agregarAna=false;
        this.lider=[];
        this.analista=[];
        this.desarrollador=[];
        this.getEquipoTrabajo();
         this.notifier.notify('error',data['errorMessage'] )
       }
       else{
         this.agregarAna=false;
         this.lider=[];
         this.analista=[];
         this.desarrollador=[];
         this.getEquipoTrabajo();
         this.notifier.notify('success', 'Lider de proyecto agregado correctamente.');
       }
     }
   );

     //Agregar confirmacion de agregar
    /*let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{opcion:9, etiqueta:'lider', nombreDesarrollador:nombreLider},disableClose:true,width: '500px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        
      }
    else{
    let valores={
      'id_iniciativa':this.idIniciativa,
      'email_usuario': this.emailLider,
      'id_rol':this.idlider,
      'comentario':this.comentarioLider,
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }
   this.dataService.insertIntegranteEquipo(valores).subscribe(
     data => {
       if (data['errorMessage']) 
       {
         this.notifier.notify('error',data['errorMessage'] )
       }
       else{
         this.agregarAna=false;
         this.lider=[];
         this.analista=[];
         this.getEquipoTrabajo();
         this.notifier.notify('success', 'Lider de proyecto agregado correctamente.');
       }
     }
   );
  }
});*/



}


  //Método para guardar desarrollador de equipo de trabajo
  guardarDesarrollador(valoresDesarrollador:string)
  {
    this.valores=valoresDesarrollador.indexOf("/");
    this.idRolDesarrollador=parseInt(valoresDesarrollador.substring(this.valores+1,valoresDesarrollador.length));
    this.emailDesarrollador=valoresDesarrollador.substring(0,this.valores);
    let nombreDesarrollador=valoresDesarrollador.substring(this.valores+3,valoresDesarrollador.length)

    let valores={
      'id_iniciativa':this.idIniciativa,
      'email_usuario': this.emailDesarrollador,
      'id_rol': this.idRolDesarrollador,
      'comentario':this.comentarioLider,
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }
  this.dataService.insertIntegranteEquipo(valores).subscribe(
    data => {
      if (data['errorMessage']) 
      {
        this.agregarAna=false;
        this.lider=[];
        this.analista=[];
        this.desarrollador=[];
        this.getEquipoTrabajo();
        this.notifier.notify('error',data['errorMessage'] )
      }
      else{
        this.agregarAna=false;
        this.lider=[];
        this.analista=[];
        this.desarrollador=[];
        this.getEquipoTrabajo();
        this.notifier.notify('success', 'Colaborador agregado correctamente.');
      }
    }
  );

    //Agregar confirmacion de agregar
    /*let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{opcion:9,nombreDesarrollador:nombreDesarrollador,etiqueta:'colaborador'},disableClose:true,width: '500px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        
      }
      else{
        
            let valores={
              'id_iniciativa':this.idIniciativa,
              'email_usuario': this.emailDesarrollador,
              'id_rol': this.idRolDesarrollador,
              'comentario':this.comentarioLider,
              'email_usuarioLogin':this.emailUser,
              'idRol_usuarioLogin':this.idRolSeleccionado
            }
          this.dataService.insertIntegranteEquipo(valores).subscribe(
            data => {
              if (data['errorMessage']) 
              {
                this.notifier.notify('error',data['errorMessage'] )
              }
              else{
                this.agregarAna=false;
                this.lider=[];
                this.analista=[];
                this.desarrollador=[];
                this.getEquipoTrabajo();
                this.notifier.notify('success', 'Colaborador agregado correctamente.');
              }
            }
          );
        
      }
  });*/

}


eliminarIntegrante(nombreAnalista:string, idUsuarioAnalista:number, idRol:number, confirmacion:boolean)
{
   //Si el integrante esta confirmado, mostramos el modal
   if(confirmacion==false)
   {

    let valores={
      'id_iniciativa':this.idIniciativa,
      'id_usuario':idUsuarioAnalista,
      'id_rol':idRol,
      'comentario':"",
      'email_usuarioLogin':this.emailUser,
      'idRol_usuarioLogin':this.idRolSeleccionado
    }

    this.dataService.deleteAnalista(valores).subscribe(
      data => {
        if (data['errorMessage']) 
        {
          this.notifier.notify('error',data['errorMessage'] )
        }
        else{

          this.lider=[];
          this.comentarioLider="";
          this.agregarAna=false;

          this.analista=[];
          this.comentarioAnalista="";

          this.desarrollador=[];
          this.comentarioDesarrollador="";

          this.gestor=[];
          this.comentarioGestor="";

          this.getEquipoTrabajo();
          this.getListAnalistas();
          this.getListLideres();
          this.getListGest();
          this.notifier.notify('success', 'Registro eliminado correctamente.');
        }
      }
    );


   }
   //Si esta confirmado
   else{
    let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{opcion:2,nombreIntegrante:nombreAnalista},disableClose:true,width: '800px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        
      }
      else{
        let valores={
          'id_iniciativa':this.idIniciativa,
          'id_usuario':idUsuarioAnalista,
          'id_rol':idRol,
          'comentario':result,
          'email_usuarioLogin':this.emailUser,
          'idRol_usuarioLogin':this.idRolSeleccionado
        }
        this.dataService.deleteAnalista(valores).subscribe(
          data => {
            if (data['errorMessage']) 
            {
              this.notifier.notify('error',data['errorMessage'] )
            }
            else{

              this.lider=[];
              this.comentarioLider="";
              this.agregarAna=false;

              this.analista=[];
              this.comentarioAnalista="";

              this.desarrollador=[];
              this.comentarioDesarrollador="";

              this.gestor=[];
              this.comentarioGestor="";

              this.getEquipoTrabajo();
              this.getListAnalistas();
              this.getListLideres();
              this.getListGest();
              this.notifier.notify('success', 'Registro eliminado correctamente.');
            }
          }
        );
      }
  });
}
}


//Método para cerrarventana de integrantes 
  cancelar(){
    this.router.navigate(['./iniciativas'])

  }

  //Método para hacer la confirmación
  confirmarEquipo()
  {
    let dialogRef = this.dialog.open(ConfirmListadoTablaIniciativasComponent,{data:{opcion:9,id_iniciativa:this.idIniciativa,rolLogin:this.idRolSeleccionado},disableClose:true,width: '800px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
        
      }
      else{
        //this.scrollInicio();
        //this.loadingGeneral=true;
            let valores={
              'id_iniciativa':this.idIniciativa,
              'email_usuarioLogin':this.emailUser,
              'idRol_usuarioLogin':this.idRolSeleccionado
            }
          this.dataService.confirmarEquipoTrabajo(valores).subscribe(
            data => {
              if (data['errorMessage'] && data['errorMessage']=='La iniciativa no cuenta con algún cambio.') 
              {
                /*this.lider=[];
                this.analista=[];
                this.desarrollador=[];
                this.getEquipoTrabajo();
                this.scrollInicio();*/
                this.notifier.notify('success', 'Equipo confirmado correctamente.');
                //this.notifier.notify('warning',data['errorMessage'] )
                this.loadingGeneral=false;
                this.cancelar();
              }
              else{
                if(data['errorMessage'])
                {
                  /*this.lider=[];
                this.analista=[];
                this.desarrollador=[];
                this.getEquipoTrabajo();
                this.scrollInicio();*/
                this.notifier.notify('error',data['errorMessage'])
                this.loadingGeneral=false;
                this.cancelar();

                }else{

                  /*this.lider=[];
                  this.analista=[];
                  this.desarrollador=[];
                  this.getEquipoTrabajo();
                  this.scrollInicio();*/
                  this.notifier.notify('success', 'Equipo confirmado correctamente.');
                  this.loadingGeneral=false;
                  this.cancelar();


                }


                //this.agregarAna=false;
               
              }
            }
          );
          
      }
  });
   
  }


  
  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // pasos cada intervalo
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

}
